import Controller from '../abstracts/Controller';
import 'scss-templates/t-not-found.scss';

export default class NotFoundController extends Controller {
  static get COMPONENTS() {
    return [
      'RecommendationEngineComponent'
    ];
  }
}
